import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { LeadSection } from 'features/lead/ui/section';
import { Grid, GridProps } from '@chakra-ui/react';
import { useDegustationBlockState } from '../store';

export type DegustationBlockProps = GridProps & React.RefAttributes<HTMLDivElement>

export const DegustationBlock: React.FC<DegustationBlockProps> = ({
    ...props
}) => {
    const { image, pdf } = useDegustationBlockState();

    return (
        <Grid
            background="#000000"
            {...props}
        >
            <Grid
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
            >
                <LeadSection
                    title="ПРИХОДИТЕ НА ДЕГУСТАЦИЮ"
                    subtitle="Запишитесь прямо сейчас"
                    sidebar={{
                        title: 'ШОУ-РУМ',
                        subtitle: 'Москва',
                    }}
                    image={image}
                    pdf={pdf}
                />
            </Grid>
        </Grid>
    );
};
